import { createApp } from 'vue'
import App from './App.vue'
import '@/style.css'
import router from './router'
import store from './store/index'
import { MotionPlugin } from '@vueuse/motion'
import i18n from './i18n'

createApp(App).use(MotionPlugin).use(router).use(store).use(i18n).mount('#app')
